export default function ({ store, redirect }) {
  // Se o usuário não está autenticado,
  // envia-o para a tela de login
  if (!store.state.app.auth.check) {
    return redirect('/login')
  }
}
